import { ADD_FILE, REMOVE_FILE, fileActions } from '../Actions/files.actiontypes';
import { FileExtendedDetails } from 'sos-common/js/commonTypes/fileupload.types';
import { filesMap } from 'sos-common/js/commonTypes/FormBaseStore.types';

function addFileToState(state: filesMap, newFile: FileExtendedDetails, fieldName: string) {
  const newState = { ...state };
  const list: FileExtendedDetails[] = state[fieldName];
  const copiedList = list && list.length ? list.slice() : [];
  const indexOfFile = copiedList.findIndex((f) => f.OriginalFilename === newFile.OriginalFilename);
  if (indexOfFile === -1) {
    copiedList.push(newFile);
  } else {
    copiedList[indexOfFile] = newFile;
  }
  newState[fieldName] = copiedList;
  return newState;
}

function removeFileToState(state: filesMap, fileToRemove: FileExtendedDetails, fieldName: string) {
  const newState = { ...state };
  const copiedList = state[fieldName].slice();
  copiedList.splice(copiedList.indexOf(fileToRemove), 1);
  newState[fieldName] = copiedList;
  return newState;
}

export function files(state: filesMap = {}, action: fileActions) {
  switch (action.type) {
    case ADD_FILE:
      return addFileToState(state, action.payload, action.fieldName);
    case REMOVE_FILE:
      return removeFileToState(state, action.payload, action.fieldName);
    default:
      return state;
  }
}
